import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ApiError, login } from "../api";
import { LanguageSwitcher } from "../i18n/LanguageSwitcher";

export function LoginPage() {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(username, password);
      navigate("/overview");
    } catch (exc) {
      if (exc instanceof ApiError && exc.status === 401) {
        setError(t("login.errorInvalid"));
      } else {
        setError(t("login.errorUnreachable"));
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login">
      <div className="login-lang">
        <LanguageSwitcher />
      </div>
      <Link to="/" className="login-brand">
        <img src="/logo-mark.png" alt="AICE — AiCruise Eye" />
      </Link>
      <form onSubmit={onSubmit}>
        <label>
          {t("login.username")}
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label>
          {t("login.password")}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={loading}>
          {loading ? t("login.submitting") : t("login.submit")}
        </button>
        <Link to="/" className="login-back">{t("login.backHome")}</Link>
      </form>
    </div>
  );
}
